exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300,400,500,700);", ""]);

// module
exports.push([module.id, ".menu-bekoshop {\n  margin-top: 20px;\n  width: calc(80vw - 4px); }\n  .menu-bekoshop .select-type-position {\n    min-width: 100px;\n    margin-top: 20px; }\n\n@media only screen and (max-width: 600px) {\n  .menu-bekoshop {\n    margin-left: 5px;\n    margin-right: 5px;\n    width: calc(100vw - 10px) !important; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/screens/menu/Menu.scss
// module id = 1630
// module chunks = 0